import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { urls } from "../../endPoints";
import { doPost } from "../../../config/fetchWrapper";

export const RetrieveCustomPlaybookQuestionsAction = createAsyncThunk(
    "retrieveCustomPlaybookQuestions",
    async (arg, { rejectWithValue }) => {
        try {
            const responseData = await doPost(urls?.retrieveCustomPlaybookQuestions, arg);
            return responseData;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const retrieveCustomPlaybookQuestionsSlice = createSlice({
    name: "retrieveCustomPlaybookQuestions",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        retrieveCustomPlaybookQuestionsReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            };
        },
    },
    extraReducers: {
        [RetrieveCustomPlaybookQuestionsAction.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = null;
        },
        [RetrieveCustomPlaybookQuestionsAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = null;
            state.data = payload;
        },
        [RetrieveCustomPlaybookQuestionsAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    },
});

export const { retrieveCustomPlaybookQuestionsReset } = retrieveCustomPlaybookQuestionsSlice.actions;
export default retrieveCustomPlaybookQuestionsSlice.reducer;
